<div class="flex flex-column">
  <div class="grid">
    <div class="col">
      <div class="flex gap-1">
        <div class="flex align-items-center justify-content-center">
          <mat-icon [ngClass]="data.textColor" class="material-symbols-outlined lg-icon-size">{{data.icon}}</mat-icon>
        </div>
        <div class="flex flex-column">
          <div class="text-xl font-bold">
            {{data.title}}
          </div>
          <div class="text-sm font-light" [innerHTML]="data.message">
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto flex h-100 align-items-center justify-content-center">
        <button mat-button (click)="snackBarRef.dismissWithAction()" color><span [class]="data.actionButton.color">{{data.actionButton.label}} ({{timer()}})</span></button>
    </div>
  </div>
</div>
